import React, { useMemo, useState ,useEffect} from "react";
import Layout from "Layout"; // nếu bạn có layout, nếu không remove
import "./TransactionHistory.scss";
import { mixGetV1,mixDelV1  } from "services/mixin";
import { useNavigate } from "react-router-dom";

import {
  Table,
  Select,
  DatePicker,
  Input,
  Button,
  Avatar,
  Badge,
  Dropdown,
  Menu,
  Pagination,
  Space,
  Breadcrumb,
  message ,
  Modal
} from "antd";
import {
  EllipsisOutlined,
  EditOutlined,
  DeleteOutlined,
  CreditCardOutlined,
  DownOutlined,
  SearchOutlined,
  CalendarOutlined,
  MoreOutlined,
  RightOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";


dayjs.extend(isBetween);

const { Option } = Select;
const { RangePicker } = DatePicker;

type Order = {
  id: number;
  code: string;
  total: number;
  status: "processing" | "success" | "new" | "canceled";
  phone: string;
  fullname: string;
  email: string;
  date: string; // ISO or DD/MM/YYYY
  qty: number;
  source?: string;
  payment?: "card" | "cod" | "other";
};

const makeFakeOrders = (n = 372) => {
  const list: Order[] = [];
  const statusList: Order["status"][] = ["processing", "success", "new", "canceled"];
  const sources = ["buso.com", "chatgpt.com", "facebook.com", "google.com"];
  for (let i = 0; i < n; i++) {
    list.push({
      id: i + 1,
      code: `DH${(2511200 + i).toString(36).toUpperCase()}`,
      total: Math.floor(Math.random() * 100000) + 45,
      status: statusList[i % statusList.length],
      phone: ["0701201245", "0765968091", "0912345678"][i % 3],
      fullname: "No name",
      email: ["chuantest@gmail.com", "nguyenphuongbinh303@gmail.com", "user" + (i + 1) + "@gmail.com"][i % 3],
      date: dayjs().subtract(i % 30, "day").format("DD/MM/YYYY"),
      qty: 1,
      source: sources[i % sources.length],
      payment: i % 2 === 0 ? "card" : "cod",
    });
  }
  return list;
};

export default function OrdersPage() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(25);
  const [loading, setLoading] = useState(false);
  const stats = [
    { title: "New Orders", count: 342, percentage: "4.07%", color: "bg-blue-100", arrow: "up" },
    { title: "Pending Orders", count: 120, percentage: "2.98%", color: "bg-yellow-100", arrow: "down" },
    { title: "Delivered Orders", count: 225, percentage: "8.56%", color: "bg-green-100", arrow: "up" },
    { title: "Total Orders", count: 9451, percentage: "24.08%", color: "bg-purple-100", arrow: "up" },
  ];

  const allOrders = useMemo(() => makeFakeOrders(372), []);
  // FILTER STATES
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [sourceFilter, setSourceFilter] = useState<string | null>(null);
  const [dateRange, setDateRange] = useState<[dayjs.ConfigType, dayjs.ConfigType] | null>(null);
  const [keyword, setKeyword] = useState("");
  // TABLE / PAGINATION
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sorter, setSorter] = useState<{ field?: string; order?: string }>({});

  // Derived filtered data
  const filtered = useMemo(() => {
    return allOrders.filter((o) => {
      if (statusFilter && o.status !== statusFilter) return false;
      if (sourceFilter && o.source !== sourceFilter) return false;
      if (dateRange) {
        const [a, b] = dateRange;
        const d = dayjs(o.date, "DD/MM/YYYY");
        if (!d.isBetween(dayjs(a), dayjs(b), "day", "[]")) return false;
      }
      if (keyword) {
        const kw = keyword.toLowerCase();
        if (!o.code.toLowerCase().includes(kw) && !o.phone.includes(kw)) return false;
      }
      return true;
    })
  }, [allOrders, statusFilter, sourceFilter, dateRange, keyword]);

  const handleDeleteOrder = (id: number) => {
    Modal.confirm({
      title: "Xác nhận xóa",
      content: "Bạn có chắc chắn muốn xóa đơn hàng này không?",
      okText: "Xóa",
      cancelText: "Hủy",
      okType: "danger",
      onOk: async () => {
        try {
          const res = await mixDelV1(`/api/v1/be/order/${id}`);
          if (res.status) {
            message.success("Xóa thành công!");
            fetchOrders(page); // reload danh sách
          } else {
            message.error(res.message || "Xóa thất bại");
          }
        } catch (err) {
          console.error(err);
          message.error("Có lỗi xảy ra khi xóa");
        }
      },
    });
  };


  const fetchOrders = async (pageNumber = 1) => {
    setLoading(true);
    try {
      const dateQuery = dateRange
        ? `&between[]=created_at,${dayjs(dateRange[0]).format("YYYY-MM-DD")},${dayjs(dateRange[1]).format("YYYY-MM-DD")}`
        : "";

      const res = await mixGetV1(
        `/api/v1/be/orders?page=${pageNumber}&limit=${limit}&sort[]=id,desc` +
          (statusFilter ? `&status=${statusFilter}` : "") +
          (sourceFilter ? `&source=${sourceFilter}` : "") +
          dateQuery +
          (keyword ? `&name=${keyword}` : "")
      );

      if (res.status) {
        setOrders(res.data.items || []);
        setTotal(res.data.total || 0);
        setPage(Number(res.data.current_page));
      }
    } catch (err) {
      console.log("Lỗi API orders:", err);
    }
    setLoading(false);
  };


  useEffect(() => {
    fetchOrders(1);
  }, [statusFilter, sourceFilter, dateRange, keyword]);


  // Columns for AntD Table
  const columns = [
    {
      title: "MÃ ĐƠN HÀNG",
      dataIndex: "code",
      key: "code",
      sorter: (a: Order, b: Order) => a.code.localeCompare(b.code),
      render: (val: string, record: Order) => (
      <a className="text-blue-600 font-semibold" href={`/lich-su/chi-tiet/${record.id}`}>{val}</a>)
    },
    {
      title: "TỔNG ĐÃ CHI",
      dataIndex: "total",
      key: "total",
      sorter: (a: Order, b: Order) => a.total - b.total,
      render: (val: number) => `${val.toLocaleString()} $`,
    },
    {
      title: "TRẠNG THÁI",
      dataIndex: "status",
      key: "status",
      width: 180,
      filters: [
        { text: "Mới", value: 1 },
        { text: "Đang Xử Lý", value: 2 },
        { text: "Đã Thanh Toán", value: 3 },
        { text: "Thất Bại", value: 4 },
      ],
      onFilter: (value, record) => record.status === value,
      render: (val) => {
        if (val === 1) return <span className="badge-new">Mới</span>;
        if (val === 2) return <span className="badge-processing">Đang Xử Lý</span>;
        if (val === 3) return <span className="badge-success">Đã Thanh Toán</span>;
        return <span className="badge-fail">Thất Bại</span>;
      },
    },
    {
      title: "KHÁCH HÀNG",
      key: "customer",
      width: 230,
      render: (_: any, record: Order) => {
        const customer = record.customer || {};
        const fullname =
          (customer.first_name || "") + " " + (customer.last_name || "");
        const avatarText = fullname.trim()
          ? fullname.trim().charAt(0).toUpperCase()
          : "U";

        return (
          <div className="flex items-center gap-2"> 
            <Avatar
              size={40}
              src={customer.avatar || undefined}
              style={{
                backgroundColor: "#d9d9d9",
                color: "#555",
                fontSize: 16,
              }}
            >
              {!customer.avatar && avatarText}
            </Avatar>

            <div className="leading-tight"> 
              {/* 👈 làm text thu nhỏ chiều cao */}
              <div className="text-[16px] font-medium truncate max-w-[150px]">
                {fullname || "Không có tên"}
              </div>
              <div className="text-[13px] text-gray-500 truncate max-w-[150px]">
                {customer.email}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "ĐIỆN THOẠI",
      dataIndex: "phone",
      key: "phone",
      render: (_: any, record: Order) => record.customer?.phone || "—",
    },
    {
      title: "SỐ LƯỢNG",
      dataIndex: "soluong",
      key: "soluong",
      width: 120,
      align: "center" as const,
    },
    {
      title: "NGÀY MUA",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a: Order, b: Order) =>
        dayjs(a.created_at).unix() - dayjs(b.created_at).unix(),

      render: (val: string) => dayjs(val).format("DD/MM/YYYY"),
    },
    {
      title: "THANH TOÁN",
      dataIndex: "payment",
      key: "payment",
      width: 150,
      align: "center" as const,
      render: (val: Order["payment"]) => <CreditCardOutlined />,
    },
    {
      title: "",
      key: "actions",
      width: 64,
      align: "right" as const,
      render: (_: any, record: Order) => {
        const menu = (
          <Menu>
            <Menu.Item
              key="edit"
              icon={<EditOutlined />}
              onClick={() => navigate(`/lich-su/chi-tiet/${record.id}`)}
            >
              Edit
            </Menu.Item>
            <Menu.Item key="delete" icon={<DeleteOutlined />}  onClick={() => handleDeleteOrder(record.id)}>Delete</Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menu} trigger={["click"]}>
            <Button type="text" icon={<MoreOutlined />} />
          </Dropdown>
        );
      },
    }
  ];

  // Table pagination & data slice (AntD Table has built-in pagination; we can pass pagination prop)
  const pagination = {
    current: page,
    pageSize,
    total: filtered.length,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50"],
    showQuickJumper: true,
    onChange: (p: number, ps?: number) => { setPage(p); if (ps) setPageSize(ps); window.scrollTo({ top: 0, behavior: 'smooth' }); }
  };

  return (
    <Layout>
      <div className="transaction-history">
        <div style={{ marginBottom: 16, display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <h2 style={{ fontWeight: 600, fontSize: 24, marginBottom: 0, color: "#6e6b7b", borderRight: "1px solid #d6dce1", paddingRight: 12 }}>
            Lịch sử giao dịch
          </h2>
          <Breadcrumb
            separator={<RightOutlined style={{ fontSize: 12, color: "#6e6b7b" }} />}
            items={[
              {
                title: (
                  <a href="#">
                    <HomeOutlined style={{ color: "#096dd9", fontSize: 16 }} />
                  </a>
                ),
              },
              { title: "Danh sách" },
            ]}
          />
        </div>

        {/* STATS ROW */}
        <div className="grid t-grid-cols-4 gap-4 mb-6">
          {stats.map((s, i) => (
            <div key={i} className={`p-4 stat-card ${s.color}`}>
              <div>
                <div className="mb-3">
                  <div className="text-left font-semibold text-gray-900">{s.title}</div>
                </div>
                <div className="flex items-center text-gray-600">
                  <div className="count leading-[28px] pr-[8px] mr-[8px] !border-r !border-[#ccc] border-solid">{s.count}</div>
                  <div className="flex items-center">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      className={`mr-2 transition-transform ${s.arrow === "down" ? "rotate-90" : "rotate-0"
                        }`}
                    >
                      <path
                        d="M6 18L18 6"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                      />
                      <path
                        d="M10 6H18V14"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                      />
                    </svg>

                    <div className="text-sm">
                      <span className="font-semibold">{s.percentage}</span> this months
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* FILTER BAR */}
        <div className="bg-white p-4 rounded-lg shadow-sm">
          <div className="filter-grid items-center">
          <Select
            allowClear
            placeholder="Chọn trạng thái"
            onChange={(v) => { setStatusFilter(v || null); setPage(1); }}
            value={statusFilter || undefined}
            className="w-full"
          >
            <Option value={1}>Mới</Option>
            <Option value={2}>Đang Xử Lý</Option>
            <Option value={3}>Đã Thanh Toán</Option>
            <Option value={4}>Thất Bại</Option>
          </Select>


            <Select
              allowClear
              placeholder="Xem tất cả"
              onChange={(v) => { setSourceFilter(v || null); setPage(1); }}
              value={sourceFilter || undefined}
              className="w-full"
            >
              <Option value="buso.com">buso.com</Option>
              <Option value="chatgpt.com">chatgpt.com</Option>
              <Option value="facebook.com">facebook.com</Option>
              <Option value="google.com">google.com</Option>
            </Select>

            <RangePicker
              className="w-full"
              onChange={(dates) => {
                if (!dates) { setDateRange(null); setPage(1); return; }
                setDateRange([dates[0], dates[1]]); setPage(1);
              }}
              format="DD/MM/YYYY"
            />

            <div className="flex gap-2">
              <Input
                placeholder="Mã đơn hàng"
                prefix={<SearchOutlined />}
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onPressEnter={() => setPage(1)}
              />
              <Button type="primary" icon={<SearchOutlined />} onClick={() => setPage(1)}>Tìm</Button>
            </div>
          </div>
        </div>

        {/* INFO COUNT */}
        <div className="bg-blue-50 border border-blue-200 px-4 py-2 rounded text-blue-700 font-medium my-4">
          Số đơn hàng:  {total}
        </div>

        {/* TABLE */}
        <div className="bg-white rounded-lg shadow-sm overflow-hidden block">
          <Table
            rowKey="id"
            columns={columns}
            loading={loading}
            dataSource={orders}
            // dataSource={filtered}
            pagination={{
              current: page,
              pageSize: limit,
              total: total,
              onChange: (p) => fetchOrders(p),
            }}
            onChange={(paginationObj, filters, sorterObj: any) => {
              // keep local state if needed
              setSorter({ field: sorterObj.field, order: sorterObj.order });
            }}
            scroll={{ x: "1000px" }}
            className="ant-table-custom"
          />
        </div>

        {/* bottom pagination (redundant if you prefer AntD's built-in) */}
        {/* <div className="flex justify-end">
          <Pagination {...pagination} />
        </div> */}
      </div>
    </Layout>
  );
}